import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IContactFields, IClaimFields, IActionRequested } from '@/common/types';

// Components
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';
import Alert from '@/components/Global/Alert.vue';
import ContactInformation from '@/components/Claims/Sections/ContactInformation.vue';
import ModalClaimSubmission from '@/components/Modal/ClaimSubmission.vue';
import Loading from '@/components/Global/Loading.vue';

// Form Components
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import TextArea from '@/components/Form/TextArea.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
import Validation from '@/components/Form/Validation.vue';

// Services
import Claims from '@/services/Claims';

import { mapGetters } from 'vuex';

// Validations
import { required, email, requiredIf } from 'vuelidate/lib/validators';

import jQuery from 'jquery';

import * as Sentry from '@sentry/browser';

@Component({
	name: 'SubmitClaimMixin',
	components: {
		Sidebar,
		Alert,
		ContactInformation,
		ModalClaimSubmission,
		Loading,
		TextField,
		SelectField,
		TextArea,
		RadioField,
		Checkbox,
		Validation,
	},
	validations: {
		claim: {
			name: {
				required,
			},
			policyNumber: {
				required,
			},
			namePatient: {
				required,
			},
			DOBPatient: {
				required,
			},
			addressPatient: {
				required,
			},
			doe: {
				required,
			},
			report_type: {
				required,
			},
			HCP: {
				requiredIf: requiredIf(vm => {
					return ['umia', 'mmic'].indexOf(vm.brand) !== -1;
				}),
			},
			phoneHCP: {
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsHCP === 'Phone Number'
					);
				}),
			},
			addressHCP: {
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsHCP === 'US Mail'
					);
				}),
			},
			emailHCP: {
				email,
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsHCP === 'Email'
					);
				}),
			},
			preferred_communicationsHCP: {
				requiredIf: requiredIf(vm => {
					return ['umia', 'mmic'].indexOf(vm.brand) !== -1;
				}),
			},
			nameSubmittedBy: {
				requiredIf: requiredIf(vm => {
					return ['umia', 'mmic'].indexOf(vm.brand) !== -1;
				}),
			},
			emailSubmittedBy: {
				email,
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsSubmittedBy === 'Email'
					);
				}),
			},
			phoneSubmittedBy: {
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsSubmittedBy === 'Phone Number'
					);
				}),
			},
			addressSubmittedBy: {
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsSubmittedBy === 'US Mail'
					);
				}),
			},
			preferred_communicationsSubmittedBy: {
				requiredIf: requiredIf(vm => {
					return ['umia', 'mmic'].indexOf(vm.brand) !== -1;
				}),
			},
			nameCorrespondence: {
				requiredIf: requiredIf(vm => {
					return ['umia', 'mmic'].indexOf(vm.brand) !== -1;
				}),
			},
			emailCorrespondence: {
				email,
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsCorrespondence === 'Email'
					);
				}),
			},
			phoneCorrespondence: {
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsCorrespondence === 'Phone Number'
					);
				}),
			},
			addressCorrespondence: {
				requiredIf: requiredIf(vm => {
					return (
						['umia', 'mmic'].indexOf(vm.brand) !== -1 &&
						vm.preferred_communicationsCorrespondence === 'US Mail'
					);
				}),
			},
			preferred_communicationsCorrespondence: {
				requiredIf: requiredIf(vm => {
					return ['umia', 'mmic'].indexOf(vm.brand) !== -1;
				}),
			},
		},
	},
})
export default class SubmitClaimMixin extends Vue {
	get policy_number() {
		this.claim.policyNumber = this.$store.getters['Policy/policy_number'];
		this.claim.brand = this.$store.getters['Brand/brand'];
		return this.$store.getters['Policy/policy_number'];
	}
	public claim: IClaimFields;
	@Getter('policies', { namespace: 'Policy' }) private policies: any;
	private error: boolean;
	private error2: boolean;
	private files: any;
	private fileLog: any;
	private isInvalid: boolean;
	private contactFields: IContactFields;
	private actionRequest: IActionRequested;
	private fileUploads: any;

	constructor() {
		super();

		this.error = false;
		this.error2 = false;
		this.files = [];
		this.fileLog = [];
		this.isInvalid = false;
		this.contactFields = {
			contact_type: '',
			name: '',
			email: '',
			phone: '',
			address: '',
			preferred_communications: '',
			special_instructions: '',
		};

		this.claim = {
			brand: this.$store.getters['Brand/brand'],
			id: '',
			name: this.$store.state.Auth !== undefined ? this.$store.state.Auth.user.name : '',
			policyNumber: null,
			HCP: '',
			phoneHCP: '',
			addressHCP: '',
			emailHCP: '',
			preferred_communicationsHCP: '',
			nameSubmittedBy: '',
			emailSubmittedBy: '',
			phoneSubmittedBy: '',
			addressSubmittedBy: '',
			preferred_communicationsSubmittedBy: '',
			nameCorrespondence: '',
			emailCorrespondence: '',
			phoneCorrespondence: '',
			addressCorrespondence: '',
			preferred_communicationsCorrespondence: '',
			other_correspondence: '',
			special_instructions: '',
			namePatient: '',
			DOBPatient: '',
			phonePatient: '',
			addressPatient: '',
			preferred_communications: '',
			loss_location_name: '',
			loss_location_address: '',
			HICN: '',
			SID: '',
			doe: '',
			dnoe: '',
			lawsuit_date_served: '',
			name_title_accepted_service: '',
			ctd_contact_name: '',
			ctd_contact_phone: '',
			ctd_contact_email: '',
			applicable_insurance_coverage: '',
			applicable_insurance_coverage_yes: '',
			report_type: 'Notice Only - Potential Claim (PCE)',
			rt_other: '',
			action_requested: [],
			reported: '',
			description: '',
			files: [],
			uploads: [],
			involved_providers: [
				{
					name: '',
					email: '',
					phone: '',
					address: '',
				},
			],
			date_served: '',
		};

		this.actionRequest = {
			ar1: '',
			ar2: '',
			ar3: '',
			ar4: '',
			ar5: '',
			ar6: '',
			ar7: '',
		};

		this.fileUploads = [];
	}

	@Watch('actionRequest', { deep: true })
	private watchActionRequest(data) {
		this.claim.action_requested = [];
		Object.keys(data).map(ar => {
			if (data[ar] !== '') {
				this.claim.action_requested.push(data[ar]);
			}
			return data[ar];
		});
	}

	@Watch('claim', { deep: true })
	private watchClaim(data) {
		window.localStorage.setItem('claim-form', JSON.stringify(data));
	}

	private removeEmptyFiles(files) {
		return files.filter(file => file.file_name !== '');
	}

	private async submitClaim() {
		this.isInvalid = false;
		this.error = false;
		this.error2 = false;
		this.$v.$touch();

		if (this.$v.$invalid) {
			this.isInvalid = true;
			this.scrollToTop();
			return;
		}

		jQuery('#ClaimSubmission').modal('show');

		const files = this.removeEmptyFiles(this.fileLog);

		try {
			// Upload Files First
			if (files.length > 0) {
				const getPresignedUrls = await Claims.getPresignedUrls(files);
				const uploadFiles = await this.uploadFiles(getPresignedUrls.data);
				console.log(uploadFiles);
				this.claim.uploads = uploadFiles
					// @ts-ignore
					.filter(uc => uc.failed === false)
					.map(uc => {
						const data = {
							// @ts-ignore
							fname: uc.fname,
							// @ts-ignore
							fileLocation: uc.fileLocation,
						};
						return data;
					});
			}
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
			this.scrollToTop();
			return;
		}

		try {
			const saveClaim = await Claims.saveClaimData(this.claim);

			jQuery('#ClaimSubmission').modal('hide');

			this.$router.push({
				name: 'claimThankYou',
				params: {
					claim: this.claim,
				},
			});

			window.localStorage.removeItem('claim-form');
		} catch (e) {
			Sentry.captureException(e);
			jQuery('#ClaimSubmission').modal('hide');
			this.error2 = true;
			this.scrollToTop();
			return;
		}
	}

	private scrollToTop() {
		window.scrollTo(0, 0);
	}

	private resetClaim() {
		window.localStorage.removeItem('claim-form');
		window.location.reload(true);
	}

	private addFile() {
		this.files.push({
			file: '',
		});
		this.fileLog.push({
			file_name: '',
			file_type: '',
			progress: 0,
			failed: false,
		});
	}

	private getDataUris(event, index) {
		const fileData = event.target.files[0];

		this.fileLog[index].file_name = fileData.name;
		this.fileLog[index].file_type = fileData.type;
		this.files[index] = fileData;
	}

	private deleteFile(index) {
		if (confirm('Are you sure you want to delete the file?') === true) {
			this.files.splice(index, 1);
			this.fileLog.splice(index, 1);
			// this.getDataUris();
		}
	}

	private async uploadFiles(signedUrls) {
		// tslint:disable-next-line: prefer-const
		let uploadResponse = [];
		return await Promise.all(
			signedUrls.map(async (url, index) => {
				const currentSignedUrl = url;

				const currentFile = await this.searchFilesArray(currentSignedUrl.fname);

				if (currentFile === false) {
					return false;
				}

				const fileLogIndex = this.fileLog.findIndex(
					file => file.file_name === currentSignedUrl.fname,
				);

				const config = {
					onUploadProgress: progressEvent => {
						Vue.nextTick(() => {
							this.fileLog[fileLogIndex].progress = Math.round(
								(progressEvent.loaded * 100) / progressEvent.total,
							);
						});
					},
				};

				try {
					const file = await Claims.uploadFiles(
						currentSignedUrl.upload_url,
						currentFile,
						config,
					);
					url.failed = false;
					uploadResponse.push(file);
				} catch (e) {
					console.log(JSON.stringify(e));
					Sentry.captureException(e);
					this.fileLog[fileLogIndex].failed = true;
					url.failed = true;
				}

				return url;
			}),
		);
	}

	private searchFilesArray(needle) {
		const getFiles = this.files;
		for (let i = getFiles.length - 1; i >= 0; i--) {
			const currentFile = getFiles[i];

			if (needle === currentFile.name) {
				return currentFile;
			}

			if (i === 0) {
				return false;
			}
		}
	}

	private created() {
		// Check to see if a claim was started, if not default to
		// empty object otherwise pull from localStorage
		if (
			window.localStorage.getItem('claim-form') !== null &&
			window.localStorage.getItem('claim-form').length > 0
		) {
			this.claim = JSON.parse(window.localStorage.getItem('claim-form'));
		}
	}
}
